import { PermissionsEnum } from "@/auth/interfaces";
import { SaveTypeRegimenes } from "../../shared/saveRegimenes";
import { useCheckPermissions } from "@/shared";
export interface CreateRegimenesPageInterface {}
const CreateRegimenesPage: React.FC<CreateRegimenesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_tiporegimen);

  return <SaveTypeRegimenes titlePage="Crear Tipo Régimen" />;
};
export default CreateRegimenesPage;